<template>
	<div class="nakladnoyWholesale">
		<div class="actions mb-2 mt-2 hidden-print">
			<div class="pull-left">
				<b-button @click="goBackToFrom" variant="outline-dark"><i class="fa fa-chevron-left"></i> {{ $t('back')
					}}
				</b-button>
			</div>
			<div class="pull-right">

				<a style="font-size: 16px;" class="mr-3" disabled
				   download>{{ $t('excel-export.download-excel') }}</a>
				<b-button
					variant="outline-dark"

					class="mr-2"

				>
					<i class="fa fa-print"></i>
					{{$t('pricing.print')}} {{$t('goods.barcode')}}
				</b-button>
				<b-button
					variant="outline-dark"
					@click="print"
					class="mr-2"
				>
					<i class="fa fa-print"></i>
					{{ $t('Печать')}}
				</b-button>
			</div>
		</div>
		<br>
		<br>
		<div class="doc-body">
			<b-card class="p-1">
				<b-row>
					<b-col cols="4">

					</b-col>
					<b-col cols="5">
						<h5 style="text-align: center">Акт переоценки товаров,материалов, тары</h5>
					</b-col>
					<b-col cols="2">
						<b style="text-align: right">"Утверждаю"</b>
					</b-col>
				</b-row>
				<br>
				<div style="line-height: 5px">
					<b-row>
						<b-col cols="2">
							<p>
								Номер
							</p>
						</b-col>
						<b-col style="margin-left: -7%" cols="3">
							<b>
								111<span> OT 30/04/21</span>
							</b>
						</b-col>
						<b-col style="margin-left: 15%" cols="4">
							<p>
								Откуда
							</p>
						</b-col>
						<b-col style="margin-left: -15%" cols="3">
							<b>
								Склад
							</b>
						</b-col>
					</b-row>
					<b-row>
						<b-col cols="2">
							<p>
								Дата
							</p>
						</b-col>
						<b-col style="margin-left: -7%" cols="3">
							<b>
								22/07/2021
							</b>
						</b-col>
						<b-col style="margin-left: 15%" cols="4">
							<p>
								Куда
							</p>
						</b-col>
						<b-col style="margin-left: -15%" cols="3">
							<b>
								Цу
							</b>
						</b-col>
					</b-row>
					<!--					<b-row>-->
					<!--					<b-col cols="2">-->
					<!--						<p>-->

					<!--						</p>-->
					<!--					</b-col>-->
					<!--					<b-col style="margin-left: -7%" cols="3">-->
					<!--						<b>-->

					<!--						</b>-->
					<!--					</b-col>-->
					<!--					<b-col style="margin-left: 15%" cols="4">-->
					<!--						<p>-->
					<!--							Прочие расхоги-->
					<!--						</p>-->
					<!--					</b-col>-->
					<!--					<b-col style="margin-left: -15%" cols="3">-->
					<!--						<b>-->
					<!--							245,000,000-->
					<!--						</b>-->
					<!--					</b-col>-->
					<!--				</b-row>-->
					<!--					<b-row>-->
					<!--						<b-col cols="2">-->
					<!--							<p>-->

					<!--							</p>-->
					<!--						</b-col>-->
					<!--						<b-col style="margin-left: -7%" cols="3">-->
					<!--							<b>-->
					<!--							</b>-->
					<!--						</b-col>-->
					<!--						<b-col style="margin-left: 15%" cols="4">-->
					<!--							<p>-->
					<!--								Сч/фактура поставщика-->
					<!--							</p>-->
					<!--						</b-col>-->
					<!--						<b-col style="margin-left: -15%" cols="3">-->
					<!--							<b>-->
					<!--								55558-->
					<!--							</b>-->
					<!--						</b-col>-->
					<!--					</b-row>-->
				</div>
				<br>
				<div class="mb-3" id="nakladnoyTableWrapper">
					<table class="table table-striped" id="tableForExcel">
						<tr>
							<th colspan="7" style="border-top: white 1px solid;border-left: 1px solid white"></th>
							<th colspan="2"  class="text-center">Цена</th>
							<th colspan="1" style="border-top: solid 1px white"></th>
							<th colspan="2"  class="text-center">Summa</th>

						</tr>
						<tr>
							<th class="text-center">№</th>
							<th class="text-center">Спецкод</th>
							<th class="text-center"> Наинования</th>
							<th class="text-center"> sorik god va data p</th>
							<th class="text-center">Пер</th>
							<th class="text-center">Кол-во</th>
							<th class="text-center">Прих ,ц</th>
							<th class="text-center">Do</th>
							<th class="text-center">Posle</th>
							<th  class="text-center">raznitsiya</th>
							<th class="text-center">Usenki</th>
							<th class="text-center">nasenki</th>

						</tr>
						<template v-for="(list, index) of data">
							<tr>
								<td width="3%" class="text-center">{{ + 1 }}</td>
								<td width="5%">
									<p>{{list.name}}</p>
								</td>
								<td width="12%">
									<p>
										{{list.Shl}}
									</p>
								</td>
								<td width="15%">
									<p>
										{{list.nazivaniyaya}}
									</p>
								</td>
								<td width="5%">
									<p>

									</p>
								</td>
								<td width="5%">
									<p class="text-center mt-3 small">{{list.kolvo}}</p>
								</td>
								<td width="5%">
									<p>

									</p>
								</td>
								<td width="5%">
									<p>

									</p>
								</td>
								<td width="5%">
									<p>

									</p>
								</td>
								<td width="5%">
									<p>

									</p>
								</td>
								<td width="5%">
									<p>

									</p>
								</td>
								<td width="5%">
									<p>

									</p>
								</td>
							</tr>
						</template>
						<tfoot >
						<tr>
							<td colspan="5"><p class="text-center">ИТОГО на сумму:</p></td>
							<td ><p class="text-center small">{{plas(data)}}</p></td>
							<td></td>
							<td style="border-right: white 1px solid"></td>
							<td style="border-right: white 1px solid"></td>
							<td></td>
							<td></td>
							<td></td>
						</tr>
						</tfoot>
					</table>
				</div>
			</b-card>
		</div>
	</div>
</template>

<script>
	export default {
		name: 'naklodnoyNew',
		data() {
			return {
				data:[
					{name:'FMG00001',Shl:'56456465456444',nazivaniyaya:'salut',kolvo:'50'},
					{name:'FMG00001',Shl:'234324234234',nazivaniyaya:'hashjdhjas',kolvo:'220'},
					{name:'FMG00001',Shl:'1231232435534',nazivaniyaya:'ahsgdhjgashjdhjas',kolvo:'150'},
					{name:'FMG00001',Shl:'564564642345456444',nazivaniyaya:'ahsgdhjgashjdhjas',kolvo:'450'},
					{name:'FMG00001',Shl:'4234324234',nazivaniyaya:'ahsgdhjgashjdhjas',kolvo:'540'},
					{name:'FMG00001',Shl:'23434',nazivaniyaya:'Salomga',kolvo:'520'},
				],
				numbers:null,
			}
		},
		methods: {
			plas(data){
				let yigindi=data.map(e=>{
				return e.kolvo
				})
				let sum=0
				for (let i =0; i<yigindi.length;i++){
					sum+=parseFloat(yigindi[i])
				}
				return sum
			},
			goBackToFrom() {
				this.$router.back();
			},
			print() {
				window.print();
			},
		},
	}
</script>

<style scoped lang="scss">
	.spinner-wrapper {
		position: absolute;
		background: rgba(32, 28, 32, 0.49);
		left: 0;
		right: 0;
		text-align: center;
		top: 0;
		bottom: 0;
		padding-top: 35px;
		z-index: 5;
	}
	.nakladnoyWholesale {
		margin: 0 20px;
	}

	@media print {
		.hidden-print {
			display: none;
		}
		.mt {
			padding-top: 200px !important;
		}
		.card {
			box-shadow: none;
		}
		#nakladnoyTableWrapper {
			display: block;
		}
	}

	.saldoInfoTexts {
		width: 88%;

		span {
			display: inline-block;
			width: 18%;
		}

		input.bottomBorderedInput {
			outline: 0;
			border-width: 0 0 .5px;
			border-color: black;
			width: 80%;
		}

		/*input.bottomBorderedInput:focus {
		border-color: green
		}*/
	}


	.signsOfAccountants {
		input.bottomBorderedInput {
			outline: 0;
			border-width: 0 0 .5px;
			border-color: black;
			width: 40%;
		}

		p {
			width: 40%;

			&.sign {
				text-align: center;
				font-size: 12px;
			}
		}
	}

	input.bottomBorderedInput {
		outline: 0;
		border-width: 0 0 .5px;
		border-color: black;

		&.width70 {
			width: 70px;
		}

		&.width80 {
			width: 80px;
		}

		&.forDate {
			width: 40px;
			text-align: right;

			&.borderRed {
				border-color: red;
				color: red;
			}
		}
	}

	h6.bottomBorderedInput {
		outline: 0;
		border-width: 0 0 .5px;
		border-color: black;

		&.width70 {
			width: 70px;
		}

		&.width80 {
			width: 80px;
		}

		&.forDate {
			width: 40px;
			text-align: right;

			&.borderRed {
				border-color: red;
				color: red;
			}
		}
	}

	#nakladnoyTableWrapper {
		.table {
			td, th {
				border: 1px solid black;
				vertical-align: middle;

				&.borderRightNone {
					border-right: none;
				}

				&.borderLeftNone {
					border-left: none;
				}

				&.borderTopNone {
					border-top: none;
				}

				&.borderBottomNone {
					border-bottom: none;
				}

				color: black;
			}

			#moldavianItemsHeader {
				th {
					font-size: 9px;
					border-bottom: none;
				}

				.width27 {
					width: 27%;
				}
			}

			#russianItemsHeader {
				th {
					font-size: 9px;
					border-top: none;
				}

				.greyText {
					color: #999999;
				}
			}

			.docItemRow {
				td {
					text-align: right;

					&.docItemUnit {
						text-align: center;
					}

					&:first-child {
						text-align: unset;
					}

					padding: 0 .5rem;
				}
			}

			th {
				font-size: 11px;
			}


			.moldavianText {
				font-weight: bold;
			}

			.fontWeightNormal {
				font-weight: normal;
			}

			tfoot {
				th, td {
					font-weight: bold;
					font-size: 11px;
					text-align: right;

					&.textAlignCenter {
						text-align: center;
					}

					&:first-child {
						text-align: unset;
					}

					padding: 0 .5rem;
				}
			}
		}
	}

	.customSize {
		font-size: 10px;
	}

	.customSizeItem {
		font-size: 12px;
	}

	.nobr {
		white-space: nowrap;
	}

	.strong {
		font-weight: bold;
	}

	#docUpperPart {
		p {
			margin-bottom: 0;
		}

		margin-bottom: .5rem;

		#docImgLogoName {
			margin-left: 32%;
			width: 300px;
			height: auto;
		}

		#docImgLogo {
			width: 180px;
			height: 70px;
		}

		#docUpperPartLeft {
			#docUpperPartTxt {
				margin-top: .5rem;
				display: inline-block;
				width: 30%;

				p {
					display: inline-block;
				}
			}

			#barcodeImgForSeria {
				cursor: pointer;
				display: inline-block;
				width: 30%;

				svg {
					vertical-align: bottom;
					width: 46mm !important;
					height: auto !important;

					g {
						text {
							font-size: 14px !important;
							transform: translateY(46px) !important;
						}
					}
				}
			}

			display: inline-block;
			width: 74%;

			#seriaInputForBarcode {
				display: inline-block;

				input {
					margin-left: .5rem;
					width: 10rem;
					height: 1.2rem;
				}
			}
		}

		#docUpperPartRight {
			display: inline-block;
			width: 26%;
			vertical-align: top;
			text-align: right;

			#rightPartTxt {
				font-size: 10px;
			}
		}
	}
</style>
